//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PopBox from './_client_remark_box'
const PICKER_TYPES = [
    {
        tags: '标记为到访客户',
        name: '到访客户',
    },
    {
        tags: '标记为意向客户',
        name: '意向客户',
    },
    {
        tags: '标记为潜在客户',
        name: '潜在客户',
    },
    {
        tags: '标记为无效客户',
        name: '无效客户',
    },
    {
        tags: '修改备注和描述',
        name: '修改',
    },
    {
        tags: '取消标记',
        name: '',
    }
]
export default {
    data() {
        return {
            show_box: false,
        }
    },
    computed: {
        picker_list() {
            const _client_mark = this.item.client_mark || ''
            return PICKER_TYPES.filter(({ name })=> {
                return name !== _client_mark
            })
        }
    },
    props: {
        show_picker: Boolean,
        item: Object,
        is_fixed: {
            type: Boolean,
            default: false
        }
    },
    components: {
        PopBox
    },
    methods: {
        setPicker(it) {
            if (it.name === '修改') {
                this.show_box = true
                this.$emit('hidePicker')
            } else {
                this.$emit('setPicker', it)
            }
        },
        editConfirm(client_name, client_description) {
            this.$emit('editConfirm', client_name, client_description)
            this.show_box = false
        }
    }
}
